import { Suspense } from "react";
import useFormatById from "src/hooks/utils/useFormatById";
// import { LoaderLazy } from "../BlogDetails";

const PageNotFound = () => {
  const formatMessage = useFormatById();

  return (
    <div className="container">
      {/* <h1 className="mt-5 text-danger mb-5" style={{ fontFeatureSettings: "'case'" }}>{formatMessage("common.PageNotFound")}!</h1> */}
      {/* <div style={{ marginTop: "50px important!" }}>
        <Suspense> <LoaderLazy className="pt-5" /> </Suspense>
      </div> */}
    </div>
  );
};

export default PageNotFound;
